module["exports"] = ["#{last_name} #{first_name}"];